import {ApiDispatcher} from '@/model/Dispatcher';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';


export enum ResourceDisponent {
  Disponent = '/Disponent',
}

export async function getDispatchers(): Promise<CombinedApiResponse<ApiDispatcher[]>> {
  const response = await doApiRequest<ApiDispatcher[]>({
    method: Method.Get,
    resource: ResourceDisponent.Disponent,
    module: Module.Stammdaten,
    useCache: true,
    select: new Set([
      'Kurz', 'Name',
    ]),
  });

  return [response.Data, response.CountAll];
}

